module.exports = __webpack_public_path__ + "static/media/pencil-calendar.34b9b129.svg";